import React from "react"
import { AppButtonIcon } from "@components"
import { useDeleteReport } from "Pages/ReportsAlerts/Reports/@hooks"
import { CircularProgress } from "@mui/material"

export default function ReportTableDeleteAction({ isRunning, idReport, name }) {

	const { isLoading, setIsLoading } = useDeleteReport(idReport, name)

	if (isLoading) return <CircularProgress size={17} sx={{ m: 0.2 }}/>

	return !isRunning && <AppButtonIcon icon="trash-can" tooltip="Delete" onClick={setIsLoading}/>
}